import { ReactComponent as Icon } from 'assets/menuWide/myBrands.svg'
import React from 'react'

export default function MyBrandsIcon(props: any) {
  return (
    <Icon {...props} />
  )
}